export default "__VITE_ASSET__ZmnXasm4__"